import { useEffect, useState } from 'react';
import OneClick from './OneClick';

const colors = [
  { id: 54, name: 'Красный', imageUrl: 'https://gbi-etalon.ru/image/cache/catalog/color/eab9c3af-fc10-46cd-8668-e5d0dc405915-50x50.png' },
  { id: 52, name: 'Красный', imageUrl: 'https://gbi-etalon.ru/image/cache/catalog/krasn-50x50.jpg' },
  { id: 53, name: 'Красный', imageUrl: 'https://gbi-etalon.ru/image/cache/catalog/cern-50x50.jpg' },
  { id: 58, name: 'Красный', imageUrl: 'https://gbi-etalon.ru/image/cache/catalog/lucido-50x50.jpg' }
];

const widths = ['1200 мм', '1000 мм', '800 мм', '600 мм'];

function App() {
  const [showOneClick, setShowOneClick] = useState(false);
  const [productTitle, setProductTitle] = useState('');

  const [colors, setColors] = useState([]);
  const [widths, setWidths] = useState([]);

  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target;
      if (target.classList.contains('js-buy-one-click-v2')) {
        console.log('Клик по js-buy-one-click-v2!');

        const productItem = target.closest('.js-product-item');
        if (productItem) {
          const titleElement = productItem.querySelector('.top .title');
          const title = titleElement?.textContent.trim() || '';
          const colorJsonBlock = productItem.querySelector('.js-color-json');
          const widthJsonBlock = productItem.querySelector('.js-widths-json');

          let parsedColors = [];
          let parsedWidths = [];

          try {
            if (colorJsonBlock?.textContent) {
              parsedColors = JSON.parse(colorJsonBlock.textContent);
            }
            if (widthJsonBlock?.textContent) {
              parsedWidths = JSON.parse(widthJsonBlock.textContent);
            }
          } catch (err) {
            console.error('Ошибка парсинга JSON:', err);
          }

          setProductTitle(title);
          setColors(parsedColors);
          setWidths(parsedWidths);
          setShowOneClick(true);
        }
      }
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return (
      <>
        {showOneClick &&
            <OneClick
                onClose={() => setShowOneClick(false)}
                title={productTitle}
                colors={colors}
                widths={widths}
            />}
      </>
  );
}

export default App;
